/* eslint-disable */
/* prettier-ignore-start */
// [GENERATED FILE; DO NOT EDIT BY HAND]

import React from "react"

var element = React.createElement("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  "aria-hidden": "true"
}, React.createElement("path", {
  fill: "#FFF",
  d: "M6.6 8.41l3.82 3.95L8.83 14 5 10.05l1.6-1.64zM13.4 6L15 7.64l-4.58 4.72-1.59-1.64L13.41 6z",
  className: "foreground"
}), React.createElement("path", {
  d: "M10 20a10 10 0 110-20 10 10 0 010 20zM6.6 8.41L5 10.05 8.83 14l1.6-1.64L6.58 8.4zM13.4 6l-4.57 4.72 1.6 1.64L15 7.64 13.4 6z"
}));

var Svg = React.forwardRef(function (props, ref) {
  var next = { ref: ref };
  for (var key in props) {
    if (props.hasOwnProperty(key)) {
      next[key] = props[key];
    }
  }
  return React.cloneElement(element, next);
});
Svg.displayName = "Success";
Svg.element = element;
export default Svg;
